import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";

// Conceptual bridge between The Method and Built at Titan Haven.
// Deliberately compact and unnumbered — Operational Intelligence is a discipline
// within THG, not the company's category. Not larger than Built at Titan Haven.
export const OperationalIntel = () => (
    <section className="py-16 md:py-20 border-b border-thg-border bg-[#0d0d0d]" data-testid="operational-intel-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
                <Reveal className="lg:col-span-4">
                    <p className="text-xs tracking-[0.25em] uppercase font-bold text-thg-tertiary">
                        The Discipline
                    </p>
                    <h2 className="mt-4 font-display text-2xl md:text-3xl tracking-tight leading-tight text-white">
                        Operational Intelligence
                    </h2>
                </Reveal>
                <Reveal delay={0.1} className="lg:col-span-8">
                    <p className="text-sm md:text-base leading-relaxed text-thg-secondary max-w-3xl">
                        Titan Haven Group develops operational intelligence from the gap between what systems report
                        and what is actually happening. The work examines operating conditions, management
                        interpretation, incentives, decision flow, frontline behavior, customer outcomes, and the
                        signals traditional reporting can miss.
                    </p>
                    <p className="mt-4 text-sm md:text-base leading-relaxed text-thg-secondary max-w-3xl">
                        That work appears in THG research and Operational Briefs — and increasingly informs the
                        systems and products we build.
                    </p>
                    <Link
                        to="/warroom"
                        data-testid="operational-intel-cta"
                        className="mt-6 inline-flex items-center gap-2 text-sm text-thg-secondary hover:text-white transition-colors duration-300 group"
                    >
                        Explore Operational Intelligence &amp; Research
                        <ArrowRight size={15} className="text-thg-red transition-transform duration-300 group-hover:translate-x-1" />
                    </Link>
                </Reveal>
            </div>
        </div>
    </section>
);
